import { ValidationError } from '../../shared/errors/BaseErrors';

export type CrawlerChannelStatus = 'pending' | 'joined' | 'request_pending' | 'failed' | 'unavailable' | 'listening';

export type CrawlerChannelSource = 'assigned' | 'dialog';

export interface CrawlerChannelEntity {
  id: number;
  link: string;
  title: string;
  telegramChannelId: number;
  status: CrawlerChannelStatus;
  source: CrawlerChannelSource;
  attempts: number;
  lastError: string;
  joinedAt?: string;
  assignedAt?: string;
}

export const MAX_CRAWLER_CHANNELS_PER_ASSIGN = 5;

export const normalizeCrawlerChannelSelection = (channelUuids: string[]): string[] => {
  const unique = Array.from(new Set((channelUuids ?? []).filter(Boolean)));
  if (unique.length === 0) throw new ValidationError('crawler-channels-empty');
  if (unique.length > MAX_CRAWLER_CHANNELS_PER_ASSIGN) throw new ValidationError('crawler-channels-too-many');
  return unique;
};

const CANCELLABLE: CrawlerChannelStatus[] = ['pending', 'request_pending', 'failed', 'unavailable'];

export const canCancelCrawlerChannel = (channel: CrawlerChannelEntity): boolean =>
  channel.source === 'assigned' && channel.id > 0 && CANCELLABLE.includes(channel.status);
